// extracted by mini-css-extract-plugin
export default {"skeleton":"ListLoading_skeleton__-QWow","shimmer":"ListLoading_shimmer__agZSD"};